// extracted by mini-css-extract-plugin
module.exports = {"labelinput-wrapper":"LabelInput_labelinput-wrapper__2Buqj","names":"LabelInput_names__1nB7J","inputs":"LabelInput_inputs__Wt-9p"};